// extracted by mini-css-extract-plugin
export default {"autosize-textarea":"text-area_autosize-textarea__uPkMm"};